module.exports = __webpack_public_path__ + "static/img/moment4.ca854c2.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/school/moment4.png
// module id = cSwD
// module chunks = 1